/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "client": {
        "nested": {
          "GeoLocation": {
            "fields": {
              "latitude": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "longitude": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "uncertaintyMeters": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.client?.nested?.GeoLocation) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE GeoLocation @ squareup/client/location.proto at 16:1
 */
export const GeoLocation = $root.lookupType('squareup.client.GeoLocation');
fixType(GeoLocation, {
  latitude: {
    required: true
  },
  longitude: {
    required: true
  }
});
Builder.createAndAttachToType(GeoLocation);